import React from "react";
import { Box } from "app/components/common";
import FastImage from "react-native-fast-image";
import SignupBottom from "../Signup/SignupBottom";
import Slides from "./Slides";
import normalize from "app/utils/normalize";

const LongDarkLogo = require("./../../../assets/images/long-dark-logo.png");

export interface IProps {
  answers: [];
  questionIndex: number;
  isLastSlide: boolean;
  requesting: boolean;
  isComingFromSignup: boolean;
  onValueChange: () => void;
  onAddChoice: () => void;
  generateCustomSlides: (answer: []) => void;
  goBack: () => void;
  goNext: () => void;
  submit: () => void;
}

const WebSurvey = ({
  answers,
  questionIndex,
  isLastSlide,
  requesting,
  onValueChange,
  onAddChoice,
  generateCustomSlides,
  goBack,
  goNext,
  submit,
}: IProps) => {
  return (
    <Box flex={1} justifyContent="center" backgroundColor="neutral.white">
      <Box variant="webOnboarding" flexDirection="column">
        <Box paddingLeft="webXXL" paddingTop="webXXL">
          <FastImage
            resizeMode="contain"
            source={LongDarkLogo}
            style={styles.webLongLogo}
          />
        </Box>
        <Box flex={1} alignItems="center">
          <Box
            flex={1}
            width={normalize(436)}
            alignItems="center"
            marginVertical="m"
          >
            {generateCustomSlides(answers).map((slide, index) => {
              if (index === questionIndex) {
                return (
                  <Slides
                    {...slide}
                    key={index}
                    onPressChoice={onAddChoice}
                    onValueChange={onValueChange}
                  />
                );
              }
              return null;
            })}
          </Box>
          <Box width={normalize(344)} alignItems="center" marginBottom="xm">
            <SignupBottom
              isRequesting={requesting}
              onPressBack={goBack}
              onPressNext={isLastSlide ? submit : goNext}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  webLongLogo: {
    height: normalize(16),
    width: normalize(110),
  },
};

export default WebSurvey;
